import React from 'react';
import { getImageByKey } from '../../scripts/getImageByKey';
import * as classes from './ContactUs.module.css';
import { useTranslation } from 'react-i18next';

export default function ContactUs() {

  // Setup translate function
  const { t } = useTranslation();

  return (
    <div className={classes.ContactUs}>
      <div className={classes.ContactUsPrimary}>
        <div className={classes.ContactUs_image}>
          <img src={getImageByKey('contactus')} alt='Hevosviihde' />
        </div>
        <div className={classes.ContactUs_description}>
          <div className={classes.ContactUs_description_Primary}>
            <h4 className='font-700'>{t('contactUs.contactUs')}</h4>
            <div className={classes.ContactUs_description_address}>
              <div
                className={`${classes.ContactUs_description_address_info} font-400`}
              >
                <div
                  className={classes.ContactUs_description_address_info_title}
                >
                  {' '}
                  {t('contactUs.address')}
                </div>
                <div>Itälahdenkatu 18 A,</div>
                <div>FI-00210 Helsinki</div>
              </div>
            </div>
            <div className={classes.ContactUs_description_email}>
              <a
                className={classes.ContactUs_description_email_button}
                href='mailto:hevosviihde@icareus.com
'
              >
                {t('contactUs.sendEmail')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
